// 常量采⽤全⼤写单词，单词之间使⽤‘_’拼接
export const USER_TYPE={
    '1': '内部用户',
    '2': '外部用户'
}

export const USER_MODE={
    '1': '启用',
    '2': '停用'
}
